import { useBreakpointIndex } from '@theme-ui/match-media';
import { FC } from 'react';

import { Link, Paragraph, Spacer, Text } from 'voom-gatsby';
import { PINK } from 'voom-gatsby/src/themes/bunionplasty/colors';

import { ReactComponent as PhoneIcon } from '~svg/icons/icon-phone.svg';

interface PhoneLinkProps {
  variant?: 'link' | 'button' | 'inline';
  fontSize?: (string | null)[] | string;
  ignoreMobile: boolean;
}

export const PhoneLink: FC<PhoneLinkProps> = ({
  variant = 'link',
  fontSize = 'md',
  ignoreMobile = false,
}) => {
  const breakpointIndex = useBreakpointIndex();
  const mobileView = !ignoreMobile && breakpointIndex < 2;
  const phoneNumber = '888-FOOT-DOC';
  const phoneNumberInline = '1-888-FOOT-DOC';
  const fullPhoneNumber = '+18883668362';

  const handlePhoneLinkClick = (e: React.MouseEvent) => {
    if (window.gtag) {
      window.gtag('event', 'Doctor Phone Number Button Clicked', {});
    }

    e.stopPropagation();
  };

  if (variant === 'inline') {
    return (
      <Link
        href={`tel:${fullPhoneNumber}`}
        onClick={handlePhoneLinkClick}
        variant="inline"
        sx={{ fontSize, display: 'inline', color: PINK, fontWeight: 'bold' }}
      >
        {phoneNumberInline}
      </Link>
    )
  }

  if (variant === 'button') {
    return (
      <Link
        href={`tel:${fullPhoneNumber}`}
        onClick={(e) => handlePhoneLinkClick(e)}
        variant={mobileView ? "buttonOutlineSm" : "buttonOutline"}
        sx={{
          display: 'flex',
          // flex: 1,
          alignItems: 'center',
          fontSize: ['xs', null, null, 'sm'],
          ':hover': {
            svg: {
              color: 'white',
            },
          },
        }}
      >
        {!mobileView && (<><PhoneIcon
          sx={{
            color: 'red',
            width: [14, null, null, 17],
            height: [14, null, null, 17],
          }}
        />
          <Spacer direction={'horizontal'} space={2}></Spacer></>
        )}
        <Text sx={{ whiteSpace: 'nowrap' }}>{mobileView ? 'Call' : phoneNumber}</Text>
      </Link>
    );
  }

  return (
    <Paragraph variant="mediumP" sx={{ display: 'flex', alignItems: 'center' }}>
      <PhoneIcon
        sx={{
          mr: 2,
          width: [16, null, null, 20],
          height: [16, null, null, 20],
        }}
      />
      <Spacer direction={'horizontal'} space={2}></Spacer>
      <Text>
        <Link
          href={`tel:${fullPhoneNumber}`}
          onClick={handlePhoneLinkClick}
          variant="inline"
          sx={{ fontSize }}
        >
          {phoneNumber}
        </Link>
      </Text>
    </Paragraph>
  );
};
